import { markRaw } from "vue";
import StDelete from "@/components/common/Delete.vue";
import { useUser } from "@/composables/useUser";
import { useTable } from "./useTable";

export const useTravellerTable = () => {
  const user = useUser();
  const table = useTable((traveller) => ({
    accountId: traveller.accountId,
    phoneNumber: traveller.phoneNumber,
    cardNumber: traveller.cardNumber,
    name: traveller.name,
    subscription: traveller.subscriptions,
    inAppPurchases: traveller.inAppPurchases ? "Ja" : "Nej",
    delete: {
      component: markRaw(StDelete),
      componentProps: { disabled: !user.state.isAdmin },
      componentEmits: ["delete"],
      clickable: true,
    },
  }));

  const getTableHeaders = () => [
    { name: "Kundnummer", isSortable: false },
    { name: "Mobilnummer", isSortable: false },
    { name: "Reskortsnummer", isSortable: false },
    { name: "Namn", isSortable: false },
    { name: "Abonnemang", isSortable: false },
    { name: "Köp i appen", isSortable: false },
    { name: "Ta bort", isSortable: false },
  ];

  return {
    ...table,
    getTableHeaders,
  };
};
